console.log('init Proteus Treatments -- 1.02');

observeSelector('.klaviyo-signup [type="tel"]', input_tel => {
  input_tel.parentNode.classList.add("js-input--tel");
})

/* START SHIPSCOUT */

document.addEventListener("DOMContentLoaded", () => {
  
  window._shipScout = window._shipScout || [];
  _shipScout.push(function (response) {
    console.log(response)

    let threshold_cents;
    if(!!response.thresholdCents){
      threshold_cents = response.thresholdCents;
    }

    dataLayer.push({
      'event': 'proteus_experiment_pageview',
      'proteus_exp_id': "JIB-06",
      'proteus_var_id': response.variant,
      'proteus_exp_name': `Free Shipping $${(threshold_cents / 100).toFixed(0)}`,
      'proteus_exp_version': "0.01",
    });

    console.log(`[JIB-SS] Free Shipping $${(threshold_cents / 100).toFixed(0)}`);

    // if(dynamicShipping)
    if(window.sessionStorage.getItem("ss-active") || typeof threshold_cents == "number"){
      window.sessionStorage.setItem("ss-active", true);
      let fs_threshold = threshold_cents/100;
      let cart_total = 0;
      // check for cart updates every .5s

      setInterval(() => {
        if(document.querySelectorAll(".js-incentives").length == 0 && typeof threshold_cents == "number"){
          document.querySelector('cart-root .cart--header').insertAdjacentHTML("beforeend", `
          <style>
          .js-incentives{
            padding: 1rem;
          }
          
          .js-incentives--message{
            font-size: .85rem;
            text-align: center;
            margin: 0 -1rem .5rem -1rem;
          }
          
          .js-incentives--message strong{
            font-weight: 600;
          }
          
          .js-incentives--bar{
            background: #eee;
            border-radius: 25px;
            height: 6px;
            position: relative;
            margin: .5em;
          }
          
          .js-incentives--bar--filled{
            display: block !important;
            transition: .5s ease width;
            width: 10%;
            background: #2e4de8;
            border-radius: 25px;
            height: 6px;
            position: absolute;
            left: 0;
            top: 0;
          }
          
          </style>
          <div class="js-incentives">
            <div class="js-incentives--message">...</div>
            <div class="js-incentives--bar">
              <div class="js-incentives--bar--filled" style="width: 0%;"></div>
            </div>
          </div>
          `);
        }
    
        if(cart_total != parseFloat(document.querySelector('cart-root .cart--total--price.money').innerText.replace("$", "").replace(" USD", ""))){

          cart_total = parseFloat(document.querySelector('cart-root .cart--total--price.money').innerText.replace("$", "").replace(" USD", ""))
          
          if(!isNaN(cart_total)){
            
            // update fs bar
            let message_text = "";
            message_text = `You are $${(fs_threshold - cart_total).toFixed(2)} away from FREE SHIPPING`;
            
            if(cart_total < fs_threshold){
              document.querySelector('.js-incentives--message').innerHTML = message_text;
              document.querySelector('.js-incentives--bar--filled').style.width = `${(cart_total / fs_threshold) * 100}%`;
            } else {
              document.querySelector('.js-incentives--message').innerHTML = `🎉 Congrats! You've unlocked FREE SHIPPING!`;
              document.querySelector('.js-incentives--bar--filled').style.width = "100%";
            } 
            console.log("cart updated...", cart_total);
            
          }
          
        }
        
      }, 500)
      
    }
  }); // _shipScout.push()
}) // DOMContentLoaded

/* START SHIPSCOUT */